import React, { useState } from "react";

import { useFeatureToggle } from "Store/featureToggles/featureToggleHooks";
import { FeatureToggle } from "Store/featureToggles/featureToggleTypes";
import { ReduxState } from "Store/rootReducer";
import { useSelector } from "react-redux";
import { ProductBackendName } from "../../Products/productTypes";
import { BankIdLogin } from "./BankIdLogin";
import { DefaultLogin } from "./DefaultLogin";
import { useBankIdLoginHandler } from "./bankIdLoginHooks";

interface Props {
  productBackendName: ProductBackendName;
}

export const StandardLogin = ({
  productBackendName,
}: Props): React.ReactElement => {
  const loginWithBankId = useFeatureToggle(FeatureToggle.LOGIN_WITH_BANK_ID);
  const [loginMode, setLoginMode] = useState(loginWithBankId ?? true);
  const { userIdentification } = useSelector((state: ReduxState) => state);
  const handleBankIdLogin = useBankIdLoginHandler();

  const validNameNin = userIdentification.current?.newCustomerResponse?.isValid;

  return loginMode ? (
    <BankIdLogin
      handleLogin={() => handleBankIdLogin()}
      setLoginMode={setLoginMode}
    />
  ) : (
    <DefaultLogin
      productBackendName={productBackendName}
      validNameNin={validNameNin}
      isLoading={userIdentification.isLoading}
    />
  );
};
